import React from "react";

const CloseIcon = ({ color = "#000", opacity = 1, size = 24, strokeWidth = 2, sx, ...props }) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M13 3L3 13M3 3L13 13" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default CloseIcon;
